import http from '@/utils/Http'


const searchState = () => {
    return {
        current_page: 1,
        per_page: 0,
        total_entries: 0,
        entries: []
    }
};

const BASE_PATH = '/v1/invoices';

const loadEntries = (path) => {
    return new Promise((resolve, reject) => {
        http.get(path)
            .then(({data}) => resolve(data))
            .catch(reject);
    })
};

export default {
    namespaced: true,
    state: {
        search: searchState()
    },
    getters: {
        search: state => state.search,
    },
    mutations: {
        resetSearch(state, defaultValues = {}) {
            state.search = Object.assign({}, searchState(), defaultValues);
        },
        setSearch(state, payload) {
            state.search = payload;
        }
    },
    actions: {
        async filter({commit, state}, path) {
            return new Promise((resolve, reject) => {
                loadEntries(path)
                    .then(data => {
                        commit('setSearch', Object.assign({}, state.search, data));
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadMore({}, path) {
            return loadEntries(path);
        },
        async resetSearch({commit}, defaultValues = {}) {
            commit('resetSearch', defaultValues);
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            // draft_token (handoff MCP, 16b) no TOPO do request — o Rails marca
            // 'emitted' e o agente descobre por invoices_draft_status.
            const draftToken = payload && payload._draft_token;
            if (payload && '_draft_token' in payload) delete payload._draft_token;

            return new Promise((resolve, reject) => {
                http.post(BASE_PATH, {invoice: payload, draft_token: draftToken})
                    .then(({data}) => resolve(data))
                    .catch(err => reject(err));
            })
        },
        async validate({commit}, payload) {
            return new Promise((resolve, reject) => {
                http.post(`${BASE_PATH}/validate`, {invoice: payload})
                    .then(({data}) => resolve(data))
                    .catch(err => reject(err));
            })
        },
        // Handoff MCP -> UI: carrega um rascunho preparado por um agente (via /mcp).
        async loadDraft({commit}, token) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/load_draft/${token}`)
                    .then(({data}) => resolve(data))
                    .catch(err => reject(err));
            })
        }
    }
}
